export function unknownErrorMessage(value: unknown, fallback = 'Unknown error'): string {
  if (value instanceof Error) return value.message || fallback
  if (typeof value === 'string') return value || fallback

  if (typeof ErrorEvent !== 'undefined' && value instanceof ErrorEvent) {
    return value.message || fallback
  }

  if (typeof Event !== 'undefined' && value instanceof Event) {
    const target = value.target as Partial<HTMLImageElement | HTMLAudioElement | HTMLScriptElement> | null
    const src = target && 'src' in target && typeof target.src === 'string' ? target.src : ''
    return src ? `Failed to load ${src}` : `${value.type || 'event'} event`
  }

  if (value && typeof value === 'object') {
    const record = value as Record<string, unknown>
    for (const key of ['message', 'error', 'reason', 'value']) {
      const message = record[key]
      if (typeof message === 'string' && message) return message
      if (message instanceof Error) return message.message || fallback
    }

    try {
      const json = JSON.stringify(value)
      if (json && json !== '{}') return json
    } catch {
      // Fall through to String conversion.
    }
  }

  const message = String(value)
  return message && message !== '[object Object]' ? message : fallback
}

export function toError(value: unknown, fallback = 'Unknown error'): Error {
  if (value instanceof Error) return value
  return new Error(unknownErrorMessage(value, fallback))
}

export function isExternalObjectUpdateRejection(value: unknown): boolean {
  const message = unknownErrorMessage(value, '')
  return (
    message.includes('Object Not Found Matching Id') && message.includes('MethodName:update')
  ) || (
    message.includes('MethodName') &&
    message.includes('update') &&
    message.includes('ParamCount') &&
    message.includes('Id')
  )
}
